export enum ClientPurpose {
  Business = "1",
  Invoice = "2",
  Payment = "3",
  Delivery = "4",
  Other = "5",
  Buyer = "6",
}
